import React from 'react'
import './ExperienceSkills.css'
import { assets } from '../../assets/assests'
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';


export const ExperienceSkills = () => {
  useEffect(() => {
  AOS.init({ 
     delay: 0,
  offset: 100,  // Snappy feel
    once: true
   });
}, []);

  return (
    <div className="experience-skills-page" id='Experience-Skills'>
      <div className="experience-left">
        <h2  data-aos="fade-right"><span>React</span> Developer Journey</h2>

        <div className="info-card" data-aos="fade-up" data-aos-delay="50">
          <h3>📌 What I Did</h3>
          <p>
            Over the past few months, I independently built full-scale projects including a Gemini AI clone, a complete Amazon clone , a Rock Paper Scissors game, and a Social Media UI. Working solo, I handled everything from layout and routing to API connections and bug fixing. These projects helped me tackle real frontend challenges — debugging React code, managing component logic, and designing responsive, user-focused interfaces — all without relying on outside help.
          </p>
        </div>

        <div className="info-card" data-aos="fade-up" data-aos-delay="100" >
          <h3>📚 What I Learned</h3>
          <p>
            I learned how to think like a developer — solving real UI problems, debugging issues, and writing clean, reusable React code. 
            I used tools like <strong>React</strong>, <strong>useState</strong>, <strong>useEffect</strong>, and <strong>GitHub</strong> in real projects, 
            not just tutorials. I also became more confident in managing component logic and organizing project files properly.
          </p>
        </div>

        <div className="info-card" data-aos="fade-up" data-aos-delay="150"  >
          <h3>🎯 What I Focus On</h3>
          <p>
           I'm committed to becoming a skilled frontend React developer. I build and iterate daily — refining component architecture, mastering state management, solving real UI problems, and sharpening my understanding of scalable app structure.
          </p>
          </div>
        </div>
          

      <div className="skills-right"  data-aos="fade-up">
        <h2 className="section-title">Skills</h2>
        <div className="skills-grid">
          <div className="skill-card" data-aos="zoom-in"><img src={assets.html_icon} alt="HTML5" /><p>HTML5</p></div>
          <div className="skill-card"  data-aos="zoom-in" data-aos-delay="100"><img src={assets.css_icon} alt="CSS3" /><p>CSS3</p></div>
          <div className="skill-card"  data-aos="zoom-in" data-aos-delay="200"><img src={assets.javascript_icon} alt="JavaScript" /><p>JavaScript</p></div>
          <div className="skill-card"  data-aos="zoom-in" data-aos-delay="300"><img src={assets.react_icon} alt="React logo" /><p>React</p></div>
          <div className="skill-card"  data-aos="zoom-in" data-aos-delay="400"><img src={assets.git_icon} alt="Git & GitHub" /><p>Git & GitHub</p></div>
          <div className="skill-card"  data-aos="zoom-in" data-aos-delay="500"><img src={assets.responsive_icon} alt="responsive" /><p>Responsive Design</p></div>
        </div>
      </div>
    </div>

  )
}
